import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { delay, filter } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/domain/base-component';
import { EssentialObject } from 'src/app/core/services/essential-object.service';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { ModuleName } from '../enums/ModuleName';
import { AngularEditorConfig } from '@kolkov/angular-editor';
interface EmailObject {
  body: string,
  subject?: string
}
@Component({
  selector: 'thomas-editor',
  templateUrl: './thomas-editor.component.html',
  styleUrls: ['./thomas-editor.component.scss']
})
export class ThomasEditorComponent extends BaseComponent implements AfterViewInit {
  logoURL;
  @ViewChild('button') button!: ElementRef;
  emailObject: EmailObject;
  @Input('emailObject') set emailObj(obj: EmailObject) {
    this.emailObject = obj;
    this.initBody();
  };
  @Input() language;
  @Input() list: any[] = [];
  @Input() single;
  @Output() reset = new EventEmitter();
  @Output() emailObjectChange = new EventEmitter();
  hugeCount;
  lgCount;
  mdCount;
  smCount;
  body: string;
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    enableToolbar: true,
    sanitize: false,
    showToolbar: true,
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
  };
  constructor(private renderer: Renderer2, private el: ElementRef, public globals: GlobalsService,) {
    super();
    this.hugeCount = globals.hugeCount;
    this.lgCount = globals.lgCount;
    this.mdCount = globals.mdCount;
    this.smCount = globals.smCount;
    this.addSubscription(this.EssentialObject$.pipe(filter((obj: EssentialObject) => obj.selectedEntity.logoURL != null), delay(500)).subscribe((obj) => {
      this.logoURL = obj.selectedEntity.logoURL;
      this.initBody();
    }));
  }

  resetClicked() {

    this.reset.emit();
  }


  ngAfterViewInit(): void {
    this.initBody();
    const toolbar = this.el.nativeElement.querySelector('.angular-editor-toolbar');
    if (toolbar && this.button) {
      this.renderer.appendChild(toolbar, this.button.nativeElement);
    }
  }

  initBody() {
    if (this.logoURL)
      this.emailObject.body = this.emailObject.body.replace('https://zensystemassets-eu.s3.eu-central-1.amazonaws.com/emailicons/ex-logo.png', this.logoURL);
    setTimeout(() => {
      this.body = this.emailObject.body;
    }, 200);
  }
  updateChangedValue(event) {
    this.body = event
    this.emailObject.body = event;
    this.emailObjectChange.emit(this.emailObject);
  }
}
